import { useEffect } from 'react';
import { Router } from 'next/router';
import { AUTH_SESSION_STORAGE_KEY, keychain } from 'shared/library/keychain';
import useInboxStore from 'shared/state/inbox';
import { useUserStoreApi } from 'shared/state/user';

export function AuthSessionSync() {
  const userStore = useUserStoreApi();

  useEffect(() => {
    let reloading = false;

    const checkSession = () => {
      if (reloading || keychain.get('apiKey') === userStore.getState().apiKey) return;
      reloading = true;

      // Clear private UI now, preserving the cookie written by the other tab.
      useInboxStore.getState().reset();
      userStore.getState().reset();
      void import('shared/components/chat/disconnect-chat-session')
        .then(({ disconnectChatSession }) => disconnectChatSession())
        .catch(() => undefined)
        .finally(() => window.location.reload());
    };
    const onStorage = (event: StorageEvent) => {
      if (event.key === AUTH_SESSION_STORAGE_KEY) checkSession();
    };
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') checkSession();
    };
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) checkSession();
    };

    window.addEventListener('storage', onStorage);
    window.addEventListener('focus', checkSession);
    window.addEventListener('pageshow', onPageShow);
    document.addEventListener('visibilitychange', onVisibilityChange);
    Router.events.on('routeChangeComplete', checkSession);

    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('focus', checkSession);
      window.removeEventListener('pageshow', onPageShow);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      Router.events.off('routeChangeComplete', checkSession);
    };
  }, [userStore]);

  return null;
}
